import { serviceHandler } from './service-executor';

export const sendVerificationEmail = (email) => {
  const URL = '/api/tenants/verify/email/send';
  const data = {
    'email': email
  };
  return serviceHandler(URL, 'POST', data);
};

export const verifyEmail = (email, token) => {
  const URL = '/api/tenants/verify/email/token';
  const data = {
    'email': email,
    'oneTimeToken': token
  };
  return serviceHandler(URL, 'POST', data);
};

export const registerUser = (user) => {
  const headers = {
    'X-Auth-Username': user.email,
    'X-Auth-Password': btoa(user.password)
  };
  const URL = '/api/tenants/registration';
  return serviceHandler(URL, 'POST', user, headers);
};